// components/PasswordInput.jsx
import { Input } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import '../../../extraStyles.css';
import Helper from "./Styles";
import classNames from "classnames";

const PasswordInput = ({
  className,
  placeholder,
  value,
  onChange,
  onBlur,
  name,
  error,
  type = "password",
  ...rest
}) => {
  const { inputDefaultClass, inputSizeClass, inputFocusClass } = Helper()
  const defaultClass = inputDefaultClass || "border rounded px-3 py-2 w-full";
  const sizeClass = inputSizeClass || "";
  const focusClass = inputFocusClass || "focus:ring focus:ring-green-500";
  return (
    <Input.Password
      name={name}
      type={type}
      placeholder={placeholder}
      className={classNames(
        defaultClass,
        sizeClass,
        focusClass,
        error && "!border-red-500",
        'custom-password-input',
        className)}
      iconRender={(visible) =>
        visible ? (
          <EyeOutlined style={{ color: "#9CA3AF" }} />
        ) : (
          <EyeInvisibleOutlined style={{ color: "#9CA3AF" }} />
        )
      }
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...rest}
    />
  );
};

export default PasswordInput;
